// =====================================
// リンクスクロール
// =====================================
jQuery(function ($) {
  let isAnimating = false;

  jQuery('a[href^="#"]').on("click", function (e) {
    e.preventDefault();
    if (isAnimating) return;
    isAnimating = true;

    const id = jQuery(this).attr("href");
    const $target = id === "#" ? jQuery("html, body") : jQuery(id);
    // const headerHeight = jQuery("header").outerHeight();
    const position = $target.offset().top - 30;
    const current = jQuery(window).scrollTop();
    const distance = Math.abs(position - current);

    let duration = distance * 0.5;
    duration = Math.max(1000, Math.min(duration, 3000));

    jQuery("html, body")
      .stop()
      .animate({ scrollTop: position }, duration, "swing", function () {
        isAnimating = false;
      });
  });

  jQuery(window).on(
    "wheel touchmove keydown DOMMouseScroll mousewheel",
    function () {
      if (isAnimating) {
        jQuery("html, body").stop();
        isAnimating = false;
      }
    }
  );
});
// =====================================
// g-nav
// =====================================
jQuery(function($){
  $('#drawer-button').on('click', function(){
    $(this).toggleClass('is-open');
    $(".g-nav").toggleClass('is-open');
  });
  $('.g-nav__list').on('click', function(){
    $('#drawer-button').removeClass('is-open');
    $('.g-nav').removeClass('is-open');
  });
});
